import React, { useEffect } from 'react'
import "./nfts.scss";
import Table from 'react-bootstrap/Table';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import axios from 'axios';
import Loader from '../../../utils/loader';
import Environment from '../../../utils/Enviroment';
import Dropdown from 'react-bootstrap/Dropdown';


const Nfts = ({
  apply,
  save,
  featuredFilter,
  trendingFilter,
  publishedFilter,
  published,
  unpublishedFilter,
  clear,
  setApply,
  setSave,
  checkedCount,
  setCheckedCount,
  checkedItems,
  setCheckedItems,
  search,
  setLoading
}) => {

  console.log(
    published, save, "testinggggg");


  const [nftID, setNftId] = useState(null);
  const [bulkId, setBulkId] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false)


  const handleShow = (id, Approved, Featured, Trending) => {
    console.log(id, "nft id......");

    setShow(true);
    setNftId(id);

    setStatuses({
      featured: Featured, // Corresponding to Featured status from API
      trending: Trending,  // Corresponding to Trending status from API
      published: Approved, // Assuming "Approved" means "Published"
    });
  }


  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [nfts, setNfts] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(nfts?.currentPage || 1);
  const [totalPages, setTotalPages] = useState(0);  // This will be updated based on API response
  const [totalItems, setTotalItems] = useState(0);  // This will be updated based on API response
  const [limit, setLimit] = useState(10);  // This will be updated based on API response

  const [statuses, setStatuses] = useState({
    featured: false,
    trending: false,
    published: false,
  });

  console.log(statuses, "statuses statuses statuses statuses");

  const handleCheckboxChange = (name) => {
    setStatuses(prevStatuses => ({
      ...prevStatuses,
      [name]: !prevStatuses[name],
    }));
  };

  // Fetch NFTs with pagination and other parameters
  const fetchNfts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Environment?.API_URL}admins/nfts`, {
        params: {
          page: currentPage,  // Dynamically set the currentPage
          limit: limit,           // Adjust the limit as needed

          ...(search && { search: search }),
          ...(featuredFilter && { isFeatured: true }), // Add if featuredFilter is true
          ...(trendingFilter && { isTrending: true }), // Add if trendingFilter is true
          ...(publishedFilter && { isApproved: true }), // Add if publishedFilter is true
          ...(unpublishedFilter && { isApproved: false }), // Add if unpublishedFilter is true
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminAccessToken')}`,
          'Content-Type': 'application/json',
        },
      });

      console.log(response, "response from API...");
      setApply(false);
      setNfts(response.data);  // Assuming the response contains NFTs in 'data'
      setTotalPages(response.data.totalPages); // Assuming response has totalPages
      setTotalItems(response.data.totalItems); // Assuming response has totalItems

    } catch (err) {
      setError("Error fetching data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNfts();
  }, [currentPage, apply, clear, search, limit]); // Re-run fetch when currentPage changes


  // Handle page change for pagination
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);  // Set the currentPage to the selected page
    }
  };

  // Generate page numbers dynamically
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(i);  // Create an array of page numbers
  }

  const collectionSettingHandle = async () => {
    try {
      setLoading(true);

      // Determine payload based on the presence of IDs in bulkId
      const payload = bulkId.length > 0
        ? { ids: bulkId } // Pass an array of IDs if bulkId is not empty
        : { id: nftID };  // Pass a single ID otherwise

      // Ensure statuses and published values are handled correctly
      const isApprovedValue = save == true ? published : statuses?.published;

      // Add the statuses to the payload
      const finalPayload = {
        ...payload,
        isFeatured: statuses?.featured,
        isTrending: statuses?.trending,
        isApproved: isApprovedValue, // Dynamically determine the approved value
      };

      // Using axios POST with the correct payload structure
      const response = await axios.post(`${Environment?.API_URL}admins/nftSetting`, finalPayload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminAccessToken')}`,
          'Content-Type': 'application/json',
        },
      });

      if (response) {
        console.log(response, "response from nftSetting API...");
        setSave(false); // Reset the save state
        handleClose();
        setCheckedItems([]);
        setBulkId([]);
        setCheckedItems({}); // Empty the checked items
        setCheckedCount(0);
        handleShow2();
        fetchNfts();
      }
    } catch (err) {
      setError("Error fetching data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (save == true) {

      collectionSettingHandle();
    }
  }, [save]);

  useEffect(() => {
    setBulkId([]);
    setCheckedItems({}); // Empty the checked items
    setCheckedCount(0);
  }, []);

  const handleCheckboxChange2 = (id) => {
    setCheckedItems((prev) => {
      const updated = { ...prev };

      if (updated[id]) {
        // If the ID is already checked, remove it
        delete updated[id];
        setBulkId((prevBulkId) => prevBulkId.filter((bulkId) => bulkId !== id)); // Remove ID from bulk IDs
      } else {
        // Otherwise, add the ID as checked
        updated[id] = true;
        setBulkId((prevBulkId) => [...prevBulkId, id]); // Add ID to bulk IDs
      }

      console.log(updated, "updated");

      const count = Object.keys(updated).length; // Count the checked items
      setCheckedCount(count); // Update the checked count
      return updated;
    });
  };



  return (
    <>
      {/* {loading && <Loader />} */}
      <div className='table_div'>
        <Table responsive className='mytablemain'>
          <thead>
            <tr>
              <th>
                <div className='leftsidediv'>
                  {/* <div class="example checkboxesnew">
                    <label class="checkbox-button">
                  
                      <input
                        type="radio"
                        className="checkbox-button__input"

                        name="category" 

                      />
                      <span class="checkbox-button__control"></span>
                    </label>

                  </div> */}
                  Item
                </div>
              </th>
              <th >Price</th>
              <th>Creator</th>
              <th >Total Minted</th>
              <th>featured</th>
              <th >trending</th>
              <th>PUBLISHED</th>
              <th >Action</th>
            </tr>
          </thead>
          <tbody>
            {
              nfts?.data?.length >= 0 ?
                nfts?.data?.map((items, index) => {
                  const convertedURL = items?.imageUrl?.replace("ipfs://", "https://ipfs.io/ipfs/");
                  const isChecked = !!checkedItems[items?._id];
                  return (
                    <tr key={index}>
                      <td>
                        <div className='tdclass'>
                          <div className='leftsidediv'>
                            <div className="example checkboxesnew">
                              <label className="checkbox-button">
                                <input
                                  type="checkbox"
                                  className="checkbox-button__input"
                                  id={`choice-${items?._id}`}
                                  name={`category-${items?._id}`}
                                  checked={isChecked}
                                  onChange={() => handleCheckboxChange2(items?._id)} // Update the state
                                />
                                <span className="checkbox-button__control"></span>
                              </label>
                            </div>
                            <div className='imgtag'>
                              <img src={items?.s3ImageUrl ? items?.s3ImageUrl : convertedURL} className='imgnew' />
                            </div>
                          </div>
                          <div>
                            <h1>{items?.name}</h1>
                            <p>{items?.collection?.name}</p>
                          </div>
                        </div>
                      </td>
                      <td ><h1>{items?.price?.toLocaleString()} USDT</h1></td>
                      <td><div className='tdtwos'>
                        <div className='imgsecond'>
                          <img className='imginnner' src={items?.creatorDetails?.picture} />
                        </div>
                        <h1>{items?.creatorDetails?.name}</h1>
                      </div></td>
                      <td><h1>{items?.totalMinted?.toLocaleString()}</h1></td>
                      <td>
                        {/* <h1>{items?.isFeatured == true ? "YES" : "NO"}</h1> */}
                        {
                          items?.isFeatured == true ?
                            <h1>YES</h1>
                            :
                            <h3>NO</h3>
                        }
                      </td>
                      <td>
                        {/* <h1>{items?.isTrending == true ? "YES" : "NO"}</h1> */}
                        {
                          items?.isTrending == true ?
                            <h1>YES</h1>
                            :
                            <h3>NO</h3>
                        }
                      </td>
                      <td>
                        {/* <h1>{items?.isApproved == true ? "YES" : "NO"}</h1> */}
                        {
                          items?.isApproved == true ?
                            <h1>YES</h1>
                            :
                            <h3>NO</h3>
                        }
                      </td>
                      <td onClick={() => handleShow(items?._id, items?.isApproved, items?.isFeatured, items?.isTrending)}>
                        <button>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8.00015 5.00003C7.40681 5.00003 6.82679 5.17598 6.33344 5.50562C5.84009 5.83526 5.45557 6.3038 5.22851 6.85198C5.00145 7.40016 4.94204 8.00336 5.05779 8.5853C5.17355 9.16724 5.45927 9.70179 5.87883 10.1213C6.29839 10.5409 6.83294 10.8266 7.41488 10.9424C7.99682 11.0581 8.60002 10.9987 9.1482 10.7717C9.69638 10.5446 10.1649 10.1601 10.4946 9.66674C10.8242 9.17339 11.0001 8.59337 11.0001 8.00003C10.9993 7.20463 10.683 6.44205 10.1206 5.87962C9.55813 5.31719 8.79555 5.00086 8.00015 5.00003ZM8.00015 10C7.60459 10 7.21791 9.88273 6.88901 9.66297C6.56011 9.4432 6.30377 9.13085 6.15239 8.76539C6.00102 8.39994 5.96141 7.99781 6.03858 7.60985C6.11575 7.22189 6.30623 6.86552 6.58594 6.58581C6.86564 6.30611 7.22201 6.11563 7.60997 6.03846C7.99793 5.96129 8.40006 6.00089 8.76552 6.15227C9.13097 6.30364 9.44333 6.55999 9.66309 6.88889C9.88285 7.21779 10.0001 7.60447 10.0001 8.00003C10.0001 8.53046 9.78944 9.03917 9.41436 9.41424C9.03929 9.78931 8.53058 10 8.00015 10ZM13.5001 8.13503C13.5026 8.04503 13.5026 7.95503 13.5001 7.86503L14.4326 6.70003C14.4815 6.63886 14.5154 6.56706 14.5315 6.49042C14.5475 6.41378 14.5454 6.33443 14.5251 6.25878C14.3723 5.68415 14.1436 5.13243 13.8451 4.61815C13.8061 4.55085 13.7518 4.4936 13.6867 4.45096C13.6216 4.40832 13.5475 4.38146 13.4701 4.37253L11.9876 4.20753C11.926 4.14253 11.8635 4.08003 11.8001 4.02003L11.6251 2.53378C11.6161 2.45641 11.5892 2.38222 11.5464 2.31711C11.5037 2.252 11.4463 2.19779 11.3789 2.15878C10.8644 1.86087 10.3127 1.63242 9.73827 1.4794C9.66257 1.45928 9.5832 1.45722 9.50655 1.47339C9.42991 1.48957 9.35814 1.52353 9.29702 1.57253L8.13515 2.50003C8.04515 2.50003 7.95515 2.50003 7.86515 2.50003L6.70015 1.5694C6.63898 1.52051 6.56718 1.48666 6.49054 1.4706C6.4139 1.45453 6.33456 1.45669 6.2589 1.4769C5.68437 1.63005 5.13268 1.85871 4.61828 2.1569C4.55097 2.19598 4.49372 2.25023 4.45108 2.31533C4.40844 2.38044 4.38158 2.45459 4.37265 2.5319L4.20765 4.0169C4.14265 4.07899 4.08015 4.14149 4.02015 4.2044L2.5339 4.37503C2.45653 4.38403 2.38234 4.41098 2.31723 4.45373C2.25213 4.49649 2.19791 4.55386 2.1589 4.62128C1.86099 5.13576 1.63255 5.68743 1.47953 6.2619C1.4594 6.33761 1.45734 6.41698 1.47352 6.49362C1.48969 6.57027 1.52365 6.64204 1.57265 6.70315L2.50015 7.86503C2.50015 7.95503 2.50015 8.04503 2.50015 8.13503L1.56953 9.30003C1.52063 9.3612 1.48679 9.43299 1.47072 9.50963C1.45465 9.58628 1.45681 9.66562 1.47703 9.74128C1.62989 10.3159 1.85857 10.8676 2.15703 11.3819C2.1961 11.4492 2.25035 11.5065 2.31546 11.5491C2.38056 11.5917 2.45472 11.6186 2.53203 11.6275L4.01453 11.7925C4.07661 11.8575 4.13911 11.92 4.20203 11.98L4.37515 13.4663C4.38415 13.5436 4.4111 13.6178 4.45386 13.6829C4.49661 13.7481 4.55398 13.8023 4.6214 13.8413C5.13588 14.1392 5.68755 14.3676 6.26203 14.5207C6.33773 14.5408 6.4171 14.5428 6.49375 14.5267C6.57039 14.5105 6.64216 14.4765 6.70328 14.4275L7.86515 13.5C7.95515 13.5025 8.04515 13.5025 8.13515 13.5L9.30015 14.4325C9.36132 14.4814 9.43311 14.5153 9.50976 14.5313C9.5864 14.5474 9.66574 14.5452 9.7414 14.525C10.316 14.3722 10.8677 14.1435 11.382 13.845C11.4493 13.8059 11.5066 13.7517 11.5492 13.6866C11.5919 13.6215 11.6187 13.5473 11.6276 13.47L11.7926 11.9875C11.8576 11.9259 11.9201 11.8634 11.9801 11.8L13.4664 11.625C13.5438 11.616 13.618 11.5891 13.6831 11.5463C13.7482 11.5036 13.8024 11.4462 13.8414 11.3788C14.1393 10.8643 14.3678 10.3126 14.5208 9.73815C14.5409 9.66245 14.543 9.58308 14.5268 9.50643C14.5106 9.42979 14.4767 9.35802 14.4276 9.2969L13.5001 8.13503ZM12.4939 7.72878C12.5045 7.90946 12.5045 8.0906 12.4939 8.27128C12.4865 8.39498 12.5252 8.51703 12.6026 8.61378L13.4895 9.7219C13.3878 10.0453 13.2575 10.3591 13.1002 10.6594L11.6876 10.8194C11.5646 10.8331 11.4511 10.8918 11.3689 10.9844C11.2486 11.1197 11.1205 11.2478 10.9851 11.3682C10.8926 11.4503 10.8338 11.5639 10.8201 11.6869L10.6633 13.0982C10.363 13.2555 10.0492 13.3858 9.72577 13.4875L8.61702 12.6007C8.5283 12.5298 8.41809 12.4912 8.30452 12.4913H8.27452C8.09385 12.5019 7.9127 12.5019 7.73202 12.4913C7.60833 12.4838 7.48627 12.5226 7.38953 12.6L6.27828 13.4875C5.95486 13.3858 5.64112 13.2555 5.34078 13.0982L5.18078 11.6875C5.16712 11.5645 5.10833 11.4509 5.01578 11.3688C4.88047 11.2485 4.75233 11.1203 4.63203 10.985C4.54986 10.8925 4.43628 10.8337 4.31328 10.82L2.90203 10.6625C2.74465 10.3622 2.61434 10.0485 2.51265 9.72503L3.39953 8.61628C3.47697 8.51953 3.51572 8.39748 3.50828 8.27378C3.49765 8.0931 3.49765 7.91195 3.50828 7.73128C3.51572 7.60758 3.47697 7.48552 3.39953 7.38878L2.51265 6.27815C2.61442 5.95474 2.74472 5.641 2.90203 5.34065L4.31265 5.18065C4.43566 5.167 4.54923 5.10821 4.6314 5.01565C4.75171 4.88035 4.87984 4.75221 5.01515 4.6319C5.10807 4.54968 5.16711 4.43585 5.18078 4.31253L5.33765 2.9019C5.63796 2.74452 5.9517 2.61422 6.27515 2.51253L7.3839 3.3994C7.48065 3.47684 7.6027 3.5156 7.7264 3.50815C7.90708 3.49753 8.08822 3.49753 8.2689 3.50815C8.3926 3.5156 8.51465 3.47684 8.6114 3.3994L9.72202 2.51253C10.0454 2.61429 10.3592 2.7446 10.6595 2.9019L10.8195 4.31253C10.8332 4.43554 10.892 4.54911 10.9845 4.63128C11.1198 4.75158 11.248 4.87972 11.3683 5.01503C11.4504 5.10758 11.564 5.16637 11.687 5.18003L13.0983 5.3369C13.2557 5.63722 13.386 5.95096 13.4876 6.2744L12.6008 7.38315C12.5226 7.48071 12.4838 7.60403 12.492 7.72878H12.4939Z" fill="#424242" />
                          </svg>Settings
                        </button>
                      </td>
                    </tr>
                  )
                })
                :
                <tr>
                  <div>No data found!</div>
                </tr>
            }
          </tbody>
        </Table>

        <div className="pagi_main">
          <div className="paginationdiv">
            <h4>
              SHOWING {(currentPage - 1) * limit + 1}-{Math.min(currentPage * limit, totalItems)} OF {totalItems}
            </h4>
            <div>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {limit} <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path d="M8.5 3.54166L8.5 13.4583M8.5 13.4583L4.25 9.20832M8.5 13.4583L12.75 9.20832" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className='dropdonwmainss'>
                    <p onClick={() => setLimit(10)}>
                      10 {limit === 10 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(30)}>
                      30 {limit === 30 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(50)}>
                      50 {limit === 50 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(100)}>
                      100 {limit === 100 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <Pagination className="pageeee">
            {/* Previous Page Button */}
            {
              totalPages > 1 &&
              <div className='rightsideee'>
                <img
                  src="\assets\leftarrow.svg"
                  alt="previous"
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{ cursor: 'pointer' }}
                  className='imggggggright'
                />
              </div>
            }

            {/* Ellipsis for skipped pages */}
            {currentPage > 5 && <Pagination.Ellipsis />}

            {/* Dynamic Page Numbers */}
            {pageItems.slice(Math.max(currentPage - 3, 0), Math.min(currentPage + 2, totalPages - 1)).map((page) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            ))}

            {/* Ellipsis for skipped pages */}
            {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

            {/* Last Page Button */}
            {totalPages > 1 && (
              <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Pagination.Item>
            )}

            {/* Next Page Button */}
            {
              totalPages > 1 &&
              <div className='rightsideee'>
                <img
                  src="\assets\righarrow.svg"
                  alt="next"
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{ cursor: 'pointer' }}
                  className='imggggggright'
                />
              </div>
            }
          </Pagination>
        </div>
      </div>


      <Modal show={show} onHide={handleClose} centered className='modal1'>
        <Modal.Header closeButton>
          <Modal.Title>Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='swtich1_head'>
            <div className='switch11'>
              <h1>Featured</h1>
              <div>
                <label className="switch1">
                  <input
                    type="checkbox"
                    checked={statuses.featured}
                    onChange={() => handleCheckboxChange('featured')} // Toggle specific checkbox
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className='switch11'>
              <h1>Trending</h1>
              <div>
                <label className="switch1">
                  <input
                    type="checkbox"
                    checked={statuses.trending}
                    onChange={() => handleCheckboxChange('trending')} // Toggle specific checkbox
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className='switch111 newstitch'>
              <h1>Published</h1>
              <div>
                <label className="switch1">
                  <input
                    type="checkbox"
                    checked={statuses.published}
                    onChange={() => handleCheckboxChange('published')} // Toggle specific checkbox
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='buttton_div'>
            <Button className='cancel' variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button className='save' variant="primary" onClick={() => {
              // handleClose();
              // handleShow2();
              collectionSettingHandle()
            }}>
              Save
            </Button>
          </div>

        </Modal.Footer>
      </Modal>



      <Modal show={show2} onHide={handleClose2} centered className='modal1'>
        <Modal.Body>
          <div className='modal2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="66" height="67" viewBox="0 0 66 67" fill="none">
              <rect width="66" height="66" transform="translate(0 0.669922)" fill="#54EB37" />
              <path d="M27.9554 47.7961L15.8466 35.6878L19.8825 31.6519L27.9554 39.7243L46.1175 21.5616L50.1534 25.5975L27.9554 47.7961Z" fill="black" />
            </svg>
            <h2>Changes saved successfully</h2>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='buttton_div'>

            <Button className='save' variant="primary" onClick={handleClose2}>
              OKAY
            </Button>
          </div>

        </Modal.Footer>
      </Modal>

    </>

  )
}

export default Nfts